import React from 'react';
import { FaVideo, FaFileAlt, FaDownload, FaMobileAlt, FaClosedCaptioning, FaRegImage, FaTrophy } from 'react-icons/fa';

const CourseIncludes = ({ course, modules }) => {
    const features = [
        {
            icon: <FaVideo />,
            text: `${course?.duration || 0} hours on-demand video`
        },
        {
            icon: <FaFileAlt />,
            text: `${modules?.length || 0} articles`
        },
        {
            icon: <FaDownload />,
            text: `${modules?.length || 0} accessible resources`
        },
        {
            icon: <FaMobileAlt />,
            text: 'Access on mobile and TV'
        },
        {
            icon: <FaClosedCaptioning />,
            text: 'Closed captions'
        },
        {
            icon: <FaRegImage />,
            text: 'Audio description in existing audio'
        },
        {
            icon: <FaTrophy />,
            text: 'Certificate of completion'
        },
    ];

    return (
        <div style={styles.container}>
            <div style={styles.contentWrapper}>
                <h2 style={styles.title}>This course includes:</h2>
                <div className="features-grid" style={styles.featuresGrid}>
                    {features.map((feature, index) => (
                        <div key={index} style={styles.featureItem}>
                            <div style={styles.iconWrapper}>
                                {React.cloneElement(feature.icon, { style: styles.icon })}
                            </div>
                            <span style={styles.featureText}>{feature.text}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CourseIncludes;

// CSS-in-JS styles
const styles = {
    container: {
        backgroundColor: '#f9fafb',
        padding: '60px 20px',
    },
    contentWrapper: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    title: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#1f2937',
        marginBottom: '32px',
    },
    featuresGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
    },
    featureItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        backgroundColor: '#ffffff',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        transition: 'transform 0.2s, box-shadow 0.2s',
        cursor: 'default',
    },
    iconWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '48px',
        height: '48px',
        backgroundColor: '#e0f2fe',
        borderRadius: '10px',
        flexShrink: 0,
    },
    icon: {
        color: '#024076',
        fontSize: '22px',
    },
    featureText: {
        fontSize: '15px',
        color: '#4b5563',
        fontWeight: '500',
        lineHeight: '1.5',
    },
};

